import { Building2, CloudSun, KeyRound, Radio, ScrollText, Users } from 'lucide-react';
import type { ModuleNav } from '@/components/layout/module-nav';

/**
 * The Admin module's navigation: who signs in and what they may do, and the
 * settings every module shares — the companies, the data sources, the weather
 * location — and what the API logged.
 */
export const ADMIN_NAV: ModuleNav = {
  left: [
    [
      {
        to: '/admin/users',
        labelKey: 'nav.users',
        icon: Users,
        capability: 'canManageUsers',
      },
      {
        to: '/admin/roles',
        labelKey: 'nav.roles',
        icon: KeyRound,
        capability: 'canManageUsers',
      },
    ],
    [
      {
        to: '/admin/companies',
        labelKey: 'nav.companies',
        icon: Building2,
        capability: 'canManageSettings',
      },
      {
        to: '/admin/sources',
        labelKey: 'nav.sources',
        icon: Radio,
        capability: 'canManageSettings',
      },
      {
        to: '/admin/weather',
        labelKey: 'weather.settingsNav',
        icon: CloudSun,
        capability: 'canManageSettings',
      },
    ],
    [
      {
        to: '/admin/logs',
        labelKey: 'nav.logs',
        icon: ScrollText,
        capability: 'canReadLogs',
      },
    ],
  ],
  right: [],
};
